webpackJsonp([96961042003272],{

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Fellows = __webpack_require__(25);
	
	var _Fellows2 = _interopRequireDefault(_Fellows);
	
	var _Signup = __webpack_require__(64);
	
	var _Signup2 = _interopRequireDefault(_Signup);
	
	var _ParentInterestForm = __webpack_require__(156);
	
	var _ParentInterestForm2 = _interopRequireDefault(_ParentInterestForm);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	}
	
	var pageTemplate = function (_React$Component) {
	    _inherits(pageTemplate, _React$Component);
	
	    function pageTemplate(props) {
	        _classCallCheck(this, pageTemplate);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	        _this.state = {
	            unlocked: true
	        };
	        return _this;
	    }
	
	    pageTemplate.prototype.componentDidMount = function componentDidMount() {
	        var page = this.props.data.page.edges[0].node;
	
	        page.protectedPage ? (this.setState({ unlocked: false }), this.setupKeyListener()) : this.setState({ unlocked: true });
	    };
	
	    pageTemplate.prototype.setupKeyListener = function setupKeyListener() {
	        var _this2 = this;
	
	        document.addEventListener('keydown', function (e) {
	            var key = e.keyCode;
	            key === 13 ? _this2.unlockPage() : null;
	        });
	    };
	
	    pageTemplate.prototype.unlockPage = function unlockPage() {
	        var input = this.refs.access;
	
	        input.value === this.props.data.page.edges[0].node.pageKey ? this.setState({ unlocked: true }) : null;
	    };
	
	    pageTemplate.prototype.render = function render() {
	        var _this3 = this;
	
	        var location = this.props.location;
	
	        var page = this.props.data.page.edges[0].node;
	        var contentfulData = this.props.data.allContentfulFellowsProfile ? this.props.data.allContentfulFellowsProfile.edges[0].node : false;
	        // console.log('page ===> ',page)
	
	        var cleanedPath = location.pathname.replace(/[/]/g, '');
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'default-page' },
	            _react2.default.createElement(
	                _CustomHelmet2.default,
	                { data: page.seo, location: location },
	                page.protectedPage && _react2.default.createElement('meta', { name: 'robots', content: 'noindex' })
	            ),
	            _react2.default.createElement(_Hero2.default, { title: page.title }),
	            !this.state.unlocked && _react2.default.createElement(
	                _Row2.default,
	                { className: 'contentWrapper capper' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '12', style: { paddingRight: '20px' } },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'text-center' },
	                        'To unlock this page please provide your access key below:'
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'access-form' },
	                        _react2.default.createElement('input', { type: 'password', name: 'accessPass', ref: 'access' }),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'button', onClick: function onClick() {
	                                    return _this3.unlockPage();
	                                } },
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Submit'
	                            )
	                        )
	                    )
	                )
	            ),
	            this.state.unlocked && _react2.default.createElement(
	                _Row2.default,
	                { className: 'contentWrapper capper' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: page.zapierUrl ? '7' : '12', tablet: '12', style: { paddingRight: '20px' } },
	                    page.introText && _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(page.introText.introText) } }),
	                    page.flexSections && page.flexSections.length > 0 && page.flexSections.map(function (section, index) {
	                        return _react2.default.createElement(
	                            'div',
	                            { className: 'section', key: index },
	                            _react2.default.createElement(
	                                _Row2.default,
	                                { className: 'no-padding section-content' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'inner', style: { width: '100%' } },
	                                    section.sectionTitle && _react2.default.createElement('h2', { className: 'h2', dangerouslySetInnerHTML: { __html: section.sectionTitle } }),
	                                    section.bannerImage && _react2.default.createElement(_gatsbyImage2.default, { style: { marginBottom: '20px' }, sizes: section.bannerImage.sizes, alt: section.bannerImage.description }),
	                                    section.sectionItems.length && section.sectionItems.map(function (item, index) {
	                                        return _react2.default.createElement(
	                                            'div',
	                                            { key: index },
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'section-group' },
	                                                item.title && _react2.default.createElement('h3', { className: 'h3', dangerouslySetInnerHTML: { __html: item.title } }),
	                                                item.text && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(item.text.text) } })
	                                            ),
	                                            _react2.default.createElement(
	                                                'div',
	                                                { className: 'section-group' },
	                                                item.question && _react2.default.createElement('h3', { className: 'h3', dangerouslySetInnerHTML: { __html: item.question } }),
	                                                item.answer && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(item.answer.answer) } })
	                                            )
	                                        );
	                                    })
	                                )
	                            )
	                        );
	                    })
	                ),
	                page.zapierUrl && cleanedPath !== 'parent-request-info' && _react2.default.createElement(
	                    _Column2.default,
	                    { ref: function ref(_ref) {
	                            _this3.col = _ref;
	                        }, width: '5', tablet: '12' },
	                    _react2.default.createElement(_Signup2.default, {
	                        title: 'REQUEST INFORMATION',
	                        description: '',
	                        zap: page.zapierUrl,
	                        fieldKey: page.hiddenFieldKey,
	                        fieldValue: page.hiddenFieldValue
	                    })
	                ),
	                page.zapierUrl && cleanedPath === 'parent-request-info' && _react2.default.createElement(
	                    _Column2.default,
	                    { ref: function ref(_ref2) {
	                            _this3.col = _ref2;
	                        }, width: '5', tablet: '12' },
	                    _react2.default.createElement(_ParentInterestForm2.default, {
	                        title: 'REQUEST INFORMATION',
	                        description: '',
	                        zap: page.zapierUrl,
	                        fieldKey: page.hiddenFieldKey,
	                        fieldValue: page.hiddenFieldValue
	                    })
	                ),
	                page.link && _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { style: { marginTop: '30px' }, className: 'hoverlink', to: page.link.link },
	                    page.link.text
	                )
	            ),
	            this.state.unlocked && page.fellows && page.fellows.title && _react2.default.createElement(
	                _Row2.default,
	                { className: 'no-top-padding no-bottom-padding' },
	                _react2.default.createElement(
	                    _Column2.default,
	                    { width: '12' },
	                    _react2.default.createElement(_Fellows2.default, {
	                        title: page.fellows.title,
	                        cards: page.fellows.fellowsCards,
	                        link: page.fellows.link
	                    })
	                )
	            )
	        );
	    };
	
	    return pageTemplate;
	}(_react2.default.Component);
	
	exports.default = pageTemplate;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-js-eb8f7ce0e231910079b6.js